import Api from '@/api/stock/api_stock.js'

export default {

    /**
     * Situations matrimonial
     */
    getMedicaments () {
        const promise = Api().get('/ordonnance_medicaments')
        return promise.then((response) => response.data)
    },

    getCategorieMedicaments() {
        const promise = Api().get('/categorie-medicaments')
        return promise.then((response) => response.data)
    },

    /**
     * Recupère les injectables
     */
    getInjections () {
        const promise = Api().get('/injectables')
        return promise.then((response) => response.data)
    },

    /**
     * Recupère les consommables dont le prix et qté sont > 0
     */
    getConsommables () {
        const promise = Api().get('/get_consommables')
        return promise.then((response) => response.data)
    },

    getListeMedicamentDisponible() {
        const promise = Api().get('/medicaments/liste/disponible')
        return promise.then((response) => response.data)
    },

    getListeConsommableDisponible() {
        const promise = Api().get('/get_consommables')
        return promise.then((response) => response.data)
    },

    getListeMedicamentsParCategorie(){
        const promise = Api().get('/medicaments/liste-ordonne')
        return promise.then(response => response.data)
    },

    getListeConsommables(){
        const promise = Api().get('/consommables')
        return promise.then(response => response.data)
    },
}